<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="section-account-details"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <h2>Account Details</h2>
    <el-form
      id="submitSettingsForm"
      ref="submitForm"
      :model="form"
      class="update-email-form"
      @submit.native.prevent
    >
      <el-row>
        <el-col
          :xs="24"
          :sm="4"
          :md="4"
          :lg="4"
        >
          Email address
        </el-col>
        <el-col
          :xs="20"
          :sm="edit.email? 20 : 16"
          :md="edit.email? 20 : 16"
          :lg="edit.email? 20 : 16"
        >
          <div v-if="!edit.email">
            <p>
              <span class="mr-2">
                {{
                  user.awaiting_verification_email
                    ? user.awaiting_verification_email
                    : user.email
                }}</span>
              <span
                v-if="user.awaiting_verification_email"
                class="tag-verification"
              >Awaiting verification</span>
            </p>
          </div>
          <div v-else>
            <div class="d-flex justify-content-between mb-4">
              <span>Update email address</span>
              <a
                role="button"
                class="btn-cancel"
                @click="()=> { edit.email = false; initializeForm() }"
              >
                Cancel
              </a>
            </div>
            <el-form-item
              prop="email"
              label="Email address"
            >
              <el-input
                v-model="form.email"
                type="email"
                name="email"
                placeholder="Email"
              />
            </el-form-item>
                
            <div
              class="form-actions"
            >
              <el-button
                type="primary"
                class="btn-submit pull-right"
                :disabled="!form.email.length"
                @click="saveEmailForm($event)"
              >
                Update
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col
          v-if="!edit.email"
          :xs="4"
          :sm="4"
          :md="4"
          :lg="4"
        >
          <el-button
            size="small"
            class="pull-right btn-edit"
            @click="edit.email = !edit.email"
          >
            Edit
          </el-button>
        </el-col>
      </el-row>
      <!--el-divider></!--el-divider-->
      <!--el-row>
        <el-col
          :xs="24"
          :sm="4"
          :md="4"
          :lg="4"
        >
          Phone Number
        </el-col>
        <el-col
          :xs="20"
          :sm="edit.contactNumber? 20 : 16"
          :md="edit.contactNumber? 20 : 16"
          :lg="edit.contactNumber? 20 : 16"
        >
          <div v-if="!edit.contactNumber">
            {{ contactNumber && contactNumber.length ? contactNumber : '&nbsp;' }}
          </div>
          <div v-else>
            <div class="d-flex justify-content-between mb-4">
              <span>Update contact number</span>
              <a
                v-if="edit.contactNumber"
                role="button"
                class="btn-cancel"
                @click="()=> { edit.contactNumber = false; initializeForm() }"
              >
                Cancel
              </a>
            </div>

            <el-form-item
              prop="contact_number"
              label="Contact number"
            >
              <el-input
                v-model="form.contact_number"
                type="text"
                name="Contact number"
                placeholder="Contact numbe"
              />
            </el-form-item>
            <div
              class="form-actions"
            >
              <el-button
                type="primary"
                class="btn-submit pull-right"
                :disabled="!form.contact_number"
                @click="saveContactNumberForm()"
              >
                Update
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="4"
          :sm="4"
          :md="4"
          :lg="4"
        >
          <el-button
            v-if="!edit.contactNumber"
            size="small"
            class="btn-edit pull-right"
            @click="edit.contactNumber = !edit.contactNumber"
          >
            Edit
          </el-button>
        </el-col>
      </!--el-row-->
      <!--el-divider></!--el-divider-->
      <!--el-row->
        <el-col
          :xs="24"
          :sm="4"
          :md="4"
          :lg="4"
        >
          Address
        </el-col>
        <el-col
          :xs="20"
          :sm="edit.address? 20 : 16"
          :md="edit.address? 20 : 16"
          :lg="edit.address? 20 : 16"
        >
          <div v-if="!edit.address">
            <div v-html="userAddress"></div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-between mb-4">
              <span>Update address</span>
              <a
                v-if="edit.address"
                role="button"
                class="btn-cancel"
                @click="()=> { edit.address = false; initializeForm() }"
              >
                Cancel
              </a>
            </div>

            <el-row>
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :sm="24"
              >
                <address-selector
                  :address="form.address"
                  @update="($event)=> form.address = $event "
                />
              </el-col>
            </el-row>

            <div
              class="form-actions"
            >
              <el-button
                type="primary"
                class="btn-submit pull-right"
                :disabled="!enableUpdateAddressButton"
                @click="saveUserAddressForm()"
              >
                Update
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="4"
          :sm="4"
          :md="4"
          :lg="4"
        >
          <el-button
            v-if="!edit.address"
            size="small"
            class="btn-edit pull-right"
            @click="() => { initializeForm(); edit.address = true}"
          >
            Edit
          </el-button>
        </el-col>
      </!--el-row-->
    </el-form>

    <el-divider></el-divider>
    <el-row>
      <el-col
        :xs="24"
        :sm="4"
        :md="4"
        :lg="4"
      >
        Password
      </el-col>
      <el-col
        :xs="20"
        :sm="16"
        :md="16"
        :lg="16"
      >
        <div v-if="!edit.password">
          *************
        </div>
        <div v-else>
          <span>Update password</span>
        </div>
      </el-col>
      <el-col
        :xs="4"
        :sm="4"
        :md="4"
        :lg="4"
      >
        <el-button
          v-if="!edit.password"
          size="small"
          class="pull-right btn-edit"
          @click="edit.password = !edit.password"
        >
          Edit
        </el-button>

        <a
          v-else
          role="button"
          class="btn-cancel float-right"
          @click="()=> { edit.password = false; initializeForm() }"
        >
          Cancel
        </a>
      </el-col>
    </el-row>
    <el-row v-if="edit.password">
      <el-col
        :xs="24"
        :sm="24"
        :md="4"
        :lg="4"
      >
        <span>&nbsp;</span>
      </el-col>
      <el-col
        :xs="20"
        :sm="20"
        :md="20"
        :lg="20"
      >
        <account-password></account-password>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <el-col
        :xs="24"
        :sm="12"
        class="mb-3"
      >
        <el-card shadow="never">
          <h2>Suspend account</h2>
          <p class="max-lines">
            Suspending your account will temporarily hide your profile from the network and pause all notifications. You can reactive your account any time by logging in
          </p>
          <el-button
            class="btn-close-suspend-account"
            type="primary"
            @click="() => { showSuspendConfirmDialog = true; action='suspend' }"
          >
            Suspend my account
          </el-button>
        </el-card>
        <suspend-account-dialog
          :visible="showSuspendConfirmDialog"
          :organisation="user.organisation"
          :user="user"
          @closed="showSuspendConfirmDialog = false"
          @nominate-new-owner="fetchOrganisationMembers()"
        ></suspend-account-dialog>
      </el-col>
      <el-col
        :xs="24"
        :sm="12"
        class="mb-3"
      >
        <el-card shadow="never">
          <h2>Close account</h2>
          <p class="max-lines">
            Closing your account will remove your profile, data and activity from the network. We’ll permanently delete all your data after 30 days
          </p>
          <el-button
            class="btn-close-suspend-account"
            type="primary"
            @click="()=>{showClosedAccountDialog = true; action='close'}"
          >
            Close my account
          </el-button>
        </el-card>
        <closed-account-dialog
          :visible="showClosedAccountDialog"
          :organisation="user.organisation"
          :user="user"
          @closed="showClosedAccountDialog = false"
          @nominate-new-owner="fetchOrganisationMembers"
        ></closed-account-dialog>
      </el-col>
    </el-row>
    <el-row v-if="user.organisation">
      <el-col
        :xs="24"
        :sm="12"
      >
        <el-card shadow="never">
          <h2>Delete organisation</h2>
          <p class="max-lines">
            Deleting your organisation will remove it’s profile from the Be Well Doncaster website. Any members will be unassociated from the organisation.
          </p>
          <el-button
            class="btn-close-suspend-account"
            type="primary"
            @click="showDeleteOrganisationDialog = true"
          >
            Delete my organisation
          </el-button>
        </el-card>
        <delete-organisation-dialog
          :visible="showDeleteOrganisationDialog"
          @closed="showDeleteOrganisationDialog = false"
        ></delete-organisation-dialog>
      </el-col>
    </el-row>
    <new-organisation-owner-dialog
      v-if="user.organisation"
      :visible="showNominationNewOwnerDialog"
      :organisation="user.organisation"
      :members="members"
      @closed="showNominationNewOwnerDialog = false"
      @selected-new-owner="onSelectedNewOwner"
    />
    <confirme-closing-account-dialog
      v-if="newNominatedOwner"
      :visible="showConfirmCloseAccountDialog"
      :new-owner="newNominatedOwner"
      :organisation-id="user.organisation.id"
      :action="action"
      @closed="showConfirmCloseAccountDialog = false"
    />
  </div>
</template>
<script>
import gsApi from "@/services/gs.api";
import AccountPassword from "./account-password";
//import AddressSelector from '@/components/partials/address-selector'
import ClosedAccountDialog from '@/components/platform/settings/ClosedAccountDialog';
import SuspendAccountDialog from '@/components/platform/settings/SuspendAccountDialog';
import NewOrganisationOwnerDialog from '@/components/platform/settings/NewOrganisationOwnerDialog'
import ConfirmeClosingAccountDialog from '@/components/platform/settings/ConfirmeClosingAccountDialog'
import DeleteOrganisationDialog from '@/components/platform/settings/DeleteOrganisationDialog'
import { mapGetters } from "vuex";
import inlineValidationErrorsMixin from '@/mixins/inlineValidationErrorsMixin'
export default {
  name: "AccountDetails",
  metaInfo: {
    title: "Account details - Settings"
  },
  components: {
    AccountPassword,
    ClosedAccountDialog,
    SuspendAccountDialog,
    NewOrganisationOwnerDialog,
    ConfirmeClosingAccountDialog,
    DeleteOrganisationDialog,
    //AddressSelector
  },
  mixins: [inlineValidationErrorsMixin],
  data() {
    return {
      validationErrors: [],
      countries:[],
      mainLoader: false,
      showSuspendConfirmDialog: false,
      showClosedAccountDialog: false,
      showDeleteOrganisationDialog: false,
      showNominationNewOwnerDialog: false,
      showConfirmCloseAccountDialog: false,
      newNominatedOwner: null,
      blockforAction: false,
      form: {
        email: "",
        contact_number:"",
        address:null
      },
      edit: {
        name: false,
        email: false,
        //contactNumber: false,
        //address: false,
        password: false
      },
      members: [],
      action: null
    };
  },
  computed: {
    ...mapGetters(["user"]),
    /*userAddress() {
      if (this.user.address) {
        let address = `${this.user.address.address_1} <br>`;
        address +=
          this.user.address.address_2 && this.user.address.address_2.length
            ? `${this.user.address.address_2},`
            : "";
        address += this.user.address.town.length ? this.user.address.town : "";
        address += this.user.address.county.length
          ? `<br>${this.user.address.county}`
          : "";
        address += `<br> ${this.user.address.post_code}`;
        return address;
      }
      return '&nbsp;';
    },*/
    enableUpdateAddressButton(){
      return this.form.address.post_code.trim().length && this.form.address.address_1.trim().length && this.form.address.town.trim().length
    }
  },
  created() {
    this.getRegisterMeta()
    this.initializeForm();
  },
  methods: {
    getRegisterMeta() {
      gsApi.globalscot.meta.index()
        .then(response => {
          this.countries = response.data.countries.data;
        }).catch(() => {
          this.$alert('An unknown error occurred. Please try again later.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        })
    },
    initializeForm() {
      this.form = {
        email: this.user.awaiting_verification_email
          ? this.user.awaiting_verification_email
          : this.user.email,
        /*contact_number: this.contactNumber, 
        address: this.user.address ? Object.assign({}, this.user.address) : {
          'address_1' : '',
          'address_2' : '',
          'post_code' : '',
          'town' : '',
          'county' : '',
          'new_mailling_address' : true
        }*/
      }
    },
    saveEmailForm() {
      if (this.user.awaiting_verification_email ) {
        if(this.form.email == this.user.email){
          this.$alert("Please verify your new email address first before you can change back to your old email or use a different new email address", "Error", {
            confirmButtonText: "Close",
            showClose: false,
            customClass: "notification-modal"
          });

          return;
        }else if (this.user.awaiting_verification_email == this.form.email){
          this.$alert("This email address is already awaiting verification, please verify it or use a different new email address", "Error", {
            confirmButtonText: "Close",
            showClose: false,
            customClass: "notification-modal"
          });

          return;
        }
      }else if (this.user.email == this.form.email){
        this.$alert("This is already your current email,  please use a different new email address", "Error", {
          confirmButtonText: "Close",
          showClose: false,
          customClass: "notification-modal"
        });
        return;
      }

      this.mainLoader = true;

      gsApi.users
        .updateEmail({awaiting_verification_email : this.form.email})
        .then(response => {
          this.mainLoader = false;
          this.validationErrors = [];
          this.$store.commit("UPDATE_USER_EMAIL", {
            awaiting_verification_email: this.form.email
          });
          this.edit.email = false;
          this.$alert(
            "You successfully updated your email , an activation email has been sent to your new address",
            "Success",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            }
          ).then(() => {
            this.$refs.submitForm.resetFields();
          });
        })
        .catch(error => {
          this.validationErrors = [];
          this.mainLoader = false;

          if (
            error.response &&
            error.response.status == 422 &&
            error.response.data
          ) {
            let errors = error.response.data.errors;
            for (let [key, value] of Object.entries(errors)) {
              this.validationErrors.push(value[0]);
            }

            this.$alert(
              this.validationErrors.join(),
              "Sorry, your request could not be processed",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal"
              }
            );
          } else {
            this.$alert(error.response.data.message, "Error", {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            });
          }
        });
    },
    /*saveContactNumberForm() {

      this.mainLoader = true;
      gsApi.users
        .updateContactNumber({contact_number: this.form.contact_number})
        .then(() => {
          this.mainLoader = false;
          this.validationErrors = [];
          this.$store.commit("UPDATE_USER_CONTACT_NUMBER", {
            contact_number: this.form.contact_number
          });
          this.edit.contactNumber = false;
          this.$alert(
            "You successfully updated your contact number",
            "Success",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            }
          ).then(() => {
            this.$refs.submitForm.resetFields();
          });
        })
        .catch(error => {
          this.validationErrors = [];
          this.mainLoader = false;

          if (
            error.response &&
            error.response.status == 422 &&
            error.response.data
          ) {
            let errors = error.response.data.errors;
            for (let [key, value] of Object.entries(errors)) {
              this.validationErrors.push(value[0]);
            }

            this.$alert(
              this.validationErrors.join(),
              "Sorry, your request could not be processed",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal"
              }
            );
          } else {
            this.$alert(error.response.data.message, "Error", {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            });
          }
        });
    },
    saveUserAddressForm() {

      this.mainLoader = true;

      gsApi.users
        .updateUserAddress(this.form.address)
        .then((response) => {
          this.mainLoader = false;
          this.validationErrors = [];

          this.$store.commit("UPDATE_MAILING_ADDRESS", {
            address: response.data
          });
          this.edit.address = false;
          this.$alert(
            "You successfully updated your address",
            "Success",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            }
          ).then(() => {
            this.$refs.submitForm.resetFields();
          });
        })
        .catch(error => {
          this.validationErrors = [];
          this.mainLoader = false;

          if (
            error.response &&
      error.response.status == 422 &&
      error.response.data
          ) {
            let errors = error.response.data.errors;
            for (let [key, value] of Object.entries(errors)) {
              this.validationErrors.push(value[0]);
            }

            this.$alert(
              this.validationErrors.join(),
              "Sorry, your request could not be processed",
              {
                confirmButtonText: "Close",
                showClose: false,
                customClass: "notification-modal"
              }
            );
          } else {
            this.$alert(error.response.data.message, "Error", {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            });
          }
        });
    }, */
    fetchOrganisationMembers(){
      this.mainLoader = true;
      gsApi.organisation
        .members(this.user.organisation.id)
        .then((response) => {
          this.members = response.data.data.filter(m => m.id != this.user.id)
          this.showNominationNewOwnerDialog = true
        })
        .catch(error => {

          this.$alert(error.response.data.message, "Error", {
            confirmButtonText: "Close",
            showClose: false,
            customClass: "notification-modal"
          });
        }).finally(() => this.mainLoader = false);
    },
    onSelectedNewOwner(newOwner){
      this.newNominatedOwner = newOwner;
      this.showNominationNewOwnerDialog = false;
      this.showConfirmCloseAccountDialog = true
    }
  }
};
</script>
<style lang="scss">
.btn-edit {
  &.el-button--small {
    min-height: 0 !important;
    padding: 5px 15px !important;
    min-width: 100px;
  }
}
.el-message-box__message p {
  line-height: 32px;
}
.tag-verification {
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  color: #e6a23c;
  padding: 0 10px;
}
.tag-success {
  background-color: #f0f9eb;
  border-color: 1px solid #e1f3d8;
  color: #67c23a;
  padding: 0 10px;
}

.btn-close-suspend-account {
  margin-top: 10px;
  background: transparent !important;
  border: transparent !important;
  padding: 10px 10px !important;
  min-height: auto;
  color: $link-blue !important;
  &:hover {
    color: $link-blue !important;
  }
  &:focus {
    box-shadow: unset;
    border-color: transparent;
    outline: unset;
  }
}

.max-lines {
  min-height: 6em;
  line-height: 1.4em;
}
</style>
